function ErrorPage({ statusCode }: Readonly<{ statusCode: number | string }>) {
  return <p id="blank_page">System error page - {statusCode}</p>;
}

export default ErrorPage;
